import { Button } from "@mui/material";
import React from "react";

const NavButton = (props: {
  text: string;
  color: string;
  icon: React.ReactNode;
  link: string;
}) => {
  return (
    <a href={props.link} target="_blank" rel="noopener noreferrer">
      <Button
        disableElevation
        variant="contained"
        sx={{
          backgroundColor: props.color,
          margin: 0.3,
          textTransform: "none",
          color: "white",
        }}
        startIcon={props.icon}
      >
        {props.text}
      </Button>
    </a>
  );
};

export default NavButton;
